// Fichier : src/components/optimization/SliderResultDisplay.jsx

import React from 'react';
import { FiLoader } from 'react-icons/fi';

// Fonction utilitaire pour formater les devises
const formatCurrency = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return '0 €';
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

const SliderResultDisplay = ({ result, isOptimizing, originalCost }) => {
  // Cas 1 : Si on est en train de charger, on affiche un loader
  if (isOptimizing) {
    return (
      <div className="flex justify-center items-center p-8 bg-gray-50 rounded-lg mt-6 border">
        <FiLoader className="animate-spin h-8 w-8 text-blue-600" />
      </div>
    );
  }

  // Cas 2 : Si aucun résultat n'est encore arrivé, on n'affiche rien du tout
  if (!result) {
    return null;
  }
  
  const { new_power_subscriptions, annual_saving_eur, expected_annual_overrun_eur } = result;

  // Cas 3 : On a un résultat, on l'affiche
  return (
    <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-xl border border-blue-200 mt-6">
      <h4 className="text-lg font-bold text-gray-800 mb-4">
        Résultat de la Simulation en Temps Réel
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Carte Gain Net */}
        <div className="bg-white p-4 rounded-lg shadow-sm text-center">
          <p className="text-sm text-gray-600 mb-1">Gain Net / an</p>
          <p className={`text-2xl font-bold ${annual_saving_eur >= 0 ? 'text-green-600' : 'text-red-600'}`}>
            {formatCurrency(annual_saving_eur)}
          </p>
        </div>
        {/* Carte Coût du Risque */}
        <div className="bg-white p-4 rounded-lg shadow-sm text-center">
          <p className="text-sm text-gray-600 mb-1">Coût du Risque (CMDPS)</p>
          <p className="text-2xl font-bold text-red-600">
            {formatCurrency(expected_annual_overrun_eur)}
          </p>
        </div>
        {/* Carte Nouveau Coût Annuel */}
        <div className="bg-white p-4 rounded-lg shadow-sm text-center">
          <p className="text-sm text-gray-600 mb-1">Nouveau Coût / an</p>
          <p className="text-2xl font-bold text-blue-700">
            {formatCurrency(originalCost - annual_saving_eur)}
          </p>
        </div>
      </div>
      
      {/* Tableau des Nouvelles Puissances */}
      <div className="mt-4 bg-white p-4 rounded-lg shadow-sm">
        <h5 className="font-semibold text-gray-800 mb-2">Nouvelles Puissances Suggérées</h5>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm">
          {Object.entries(new_power_subscriptions).map(([period, power]) => (
            <div key={period} className="bg-gray-50 p-3 rounded text-center">
              <p className="font-semibold text-gray-700">{period.toUpperCase()}</p>
              <p className="font-bold text-blue-600">{parseFloat(power).toFixed(1)} kVA</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SliderResultDisplay;